import {BaseService} from "./base.service";

class TestlabhospService extends BaseService {
    constructor() {
        super('api/test-labs-hosp');
    }
}

export const testlabhospService = new TestlabhospService();
